import React from 'react'
import PropTypes from 'prop-types'
import isNil from 'lodash/isNil'
import { mergeProps } from 'src/util'
import styles from './Input.scss'

const Input = ({ color, active, disabled, error, alignRight, onChange, readOnly, ...domProps }) => (
  <input
    {...mergeProps()(
      {
        disabled,
        onChange,
        readOnly: readOnly !== undefined ? readOnly : !onChange,
        className: [
          styles.input,
          {
            [styles.active]: active,
            [styles.disabled]: disabled,
            [styles.error]: error,
            'text-right': alignRight || (isNil(alignRight) && domProps.type === 'number'),
          },
        ],
      },
      domProps
    )}
  />
)

Input.defaultProps = {
  color: 'light',
  active: false,
}

Input.propTypes = {
  /**
   * The focus color.
   */
  color: PropTypes.string,
  /**
   * Whether the focus color should be applied.
   */
  active: PropTypes.bool,
  /**
   * Whether the input is disabled or not.
   */
  disabled: PropTypes.bool,
  /**
   * In case of error.
   */
  error: PropTypes.node,
  /**
   * Align the input content to the right.
   */
  alignRight: PropTypes.bool,
  onChange: PropTypes.func,
  readOnly: PropTypes.bool,
}

export default Input
